module.exports = __webpack_public_path__ + "img/384fec8.png";